import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { get_indices3txodfl5wuu5j as get_indices } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ListClass;
function List() {
  if (ListClass === VOID) {
    class $ extends State() {
      constructor(list) {
        super();
        this.list_1 = list;
      }
      toString() {
        return 'List (' + this.list_1.get_size_woubt6_k$() + ')';
      }
    }
    initMetadataForClass($, 'List');
    ListClass = $;
  }
  return ListClass;
}
var MapClass;
function Map() {
  if (MapClass === VOID) {
    class $ extends State() {
      constructor(map, name) {
        super();
        this.map_1 = map;
        this.name_1 = name;
      }
      toString() {
        return 'Map (' + this.name_1 + ')';
      }
    }
    initMetadataForClass($, 'Map');
    MapClass = $;
  }
  return MapClass;
}
var StateClass;
function State() {
  if (StateClass === VOID) {
    class $ {}
    initMetadataForClass($, 'State');
    StateClass = $;
  }
  return StateClass;
}
function mergeWith($this, $receiver, other) {
  if ($receiver == null) {
    return other;
  }
  if (other == null) {
    return $receiver;
  }
  var tmp;
  if (isInterface($receiver, KtList())) {
    // Inline function 'kotlin.check' call
    if (!isInterface(other, KtList())) {
      var message = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
    }
    // Inline function 'kotlin.check' call
    if (!($receiver.get_size_woubt6_k$() === other.get_size_woubt6_k$())) {
      var message_0 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_0));
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_indices($receiver);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.first_1;
    var last = this_0.last_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var i = item;
        var tmp$ret$6 = mergeWith($this, $receiver.get_c1px32_k$(i), other.get_c1px32_k$(i));
        destination.add_utx5q5_k$(tmp$ret$6);
      }
       while (!(item === last));
    tmp = destination;
  } else {
    if (isInterface($receiver, KtMap())) {
      // Inline function 'kotlin.check' call
      if (!isInterface(other, KtMap())) {
        var message_1 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_1));
      }
      if (!isInterface($receiver, KtMap()))
        THROW_CCE();
      if (!isInterface(other, KtMap()))
        THROW_CCE();
      // Inline function 'kotlin.collections.map' call
      var this_1 = plus($receiver.get_keys_wop4xp_k$(), other.get_keys_wop4xp_k$());
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s = this_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var item_0 = _iterator__ex2g4s.next_20eer_k$();
        var tmp$ret$11 = to(item_0, mergeWith($this, $receiver.get_wei43m_k$(item_0), other.get_wei43m_k$(item_0)));
        destination_0.add_utx5q5_k$(tmp$ret$11);
      }
      tmp = toMap(destination_0);
    } else {
      // Inline function 'kotlin.check' call
      if (!equals($receiver, other)) {
        // Inline function 'kotlin.error' call
        var message_2 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_2));
      }
      tmp = $receiver;
    }
  }
  return tmp;
}
function valueInternal($this, value) {
  // Inline function 'kotlin.apply' call
  var state = lastOrNull($this.stack_1);
  if (state instanceof Map()) {
    var name = state.name_1;
    // Inline function 'kotlin.check' call
    if (!!(name == null)) {
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
    }
    if (state.map_1.containsKey_aw81wo_k$(name)) {
      var tmp0 = state.map_1;
      // Inline function 'kotlin.collections.set' call
      var value_0 = mergeWith($this, state.map_1.get_wei43m_k$(name), value);
      tmp0.put_4fpzoq_k$(name, value_0);
    } else {
      // Inline function 'kotlin.collections.set' call
      state.map_1.put_4fpzoq_k$(name, value);
    }
    state.name_1 = null;
  } else {
    if (state instanceof List()) {
      state.list_1.add_utx5q5_k$(value);
    } else {
      $this.root_1 = value;
      $this.rootSet_1 = true;
    }
  }
  return $this;
}
var MapJsonWriterClass;
function MapJsonWriter() {
  if (MapJsonWriterClass === VOID) {
    class $ {
      constructor() {
        this.root_1 = null;
        this.rootSet_1 = false;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.stack_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      root_235k2_k$() {
        // Inline function 'kotlin.check' call
        if (!this.rootSet_1) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        return this.root_1;
      }
      beginArray_hxn19s_k$() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableListOf' call
        var list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.stack_1.add_utx5q5_k$(new (List())(list));
        return this;
      }
      endArray_s2tmpq_k$() {
        // Inline function 'kotlin.apply' call
        var state = this.stack_1.removeAt_6niowx_k$(this.stack_1.get_size_woubt6_k$() - 1 | 0);
        // Inline function 'kotlin.check' call
        if (!(state instanceof List())) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        valueInternal(this, state.list_1);
        return this;
      }
      beginObject_5wddq0_k$() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableMapOf' call
        var map = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        this.stack_1.add_utx5q5_k$(new (Map())(map, null));
        return this;
      }
      endObject_ofuv3u_k$() {
        // Inline function 'kotlin.apply' call
        var state = this.stack_1.removeAt_6niowx_k$(this.stack_1.get_size_woubt6_k$() - 1 | 0);
        // Inline function 'kotlin.check' call
        if (!(state instanceof Map())) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        valueInternal(this, state.map_1);
        return this;
      }
      name_i73qwh_k$(name) {
        // Inline function 'kotlin.apply' call
        var state = last(this.stack_1);
        // Inline function 'kotlin.check' call
        if (!(state instanceof Map())) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(state.name_1 == null)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        state.name_1 = name;
        return this;
      }
      get_path_wos8ry_k$() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.stack_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp;
          if (item instanceof List()) {
            tmp = item.list_1.get_size_woubt6_k$().toString();
          } else {
            if (item instanceof Map()) {
              var tmp1_elvis_lhs = item.name_1;
              tmp = tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
            } else {
              noWhenBranchMatchedException();
            }
          }
          var tmp$ret$2 = tmp;
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return joinToString(destination, '.');
      }
      value_hphtnt_k$(value) {
        return valueInternal(this, value);
      }
      value_z3qus4_k$(value) {
        return valueInternal(this, value);
      }
      value_pfghfv_k$(value) {
        return valueInternal(this, value);
      }
      value_2irneh_k$(value) {
        return valueInternal(this, value);
      }
      value_hdgek3_k$(value) {
        return valueInternal(this, value);
      }
      value_pycfpt_k$(value) {
        return valueInternal(this, value);
      }
      value_bxcuou_k$(value) {
        return valueInternal(this, null);
      }
      nullValue_h3u4a2_k$() {
        return valueInternal(this, null);
      }
      close_yn9xrc_k$() {
      }
    }
    initMetadataForClass($, 'MapJsonWriter', MapJsonWriter);
    MapJsonWriterClass = $;
  }
  return MapJsonWriterClass;
}
//region block: exports
export {
  MapJsonWriter as MapJsonWriter4jz7ym6vbwk4,
};
//endregion

//# sourceMappingURL=MapJsonWriter.mjs.map
